import { Injectable } from '@angular/core';
 
import { HttpService } from '../shared/services/index';

const endPoint = 'xbcCustomers';

@Injectable()
export class SetupBillingCustomerStore {
    constructor(protected httpService: HttpService) {}

    getAll(params: any): any {
        return this.httpService.getAll(endPoint, params);
    }

    store(element: any): any {
        return this.httpService.store(endPoint, element);
    }

    patch(elementID: string, updatedElement: any): any {
		return this.httpService.patch(endPoint, elementID, updatedElement);
	}

    update(elementID: string, newElement: any): any {
        return this.httpService.update(endPoint, elementID, newElement);
    }

    get(elementID: any): any {
        return this.httpService.get(endPoint, elementID);
    }

    destroy(elementID: any): any {
        return this.httpService.destroy(endPoint, elementID);
    }
}
